export const TOGGLE_PARKING_SPECIFIC_DETAIL_PANEL = 'TOGGLE_PARKING_SPECIFIC_DETAIL_PANEL'

export function displayParkingSpecificDetailPanelReducer (state = false, action) {
    switch (action.type){
        case TOGGLE_PARKING_SPECIFIC_DETAIL_PANEL:
            return action.payload
        default: return state
    }
}